import { render, staticRenderFns } from "./ExchangeBox.vue?vue&type=template&id=247e617e&scoped=true"
import script from "./ExchangeBox.vue?vue&type=script&lang=js"
export * from "./ExchangeBox.vue?vue&type=script&lang=js"
import style0 from "./ExchangeBox.vue?vue&type=style&index=0&id=247e617e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247e617e",
  null
  
)

export default component.exports